import ENTRY_AVATAR_1_IMAGE_URL from './entry/entryAvatars/entryAvatar1.png';
import ENTRY_AVATAR_2_IMAGE_URL from './entry/entryAvatars/entryAvatar2.png';
import ENTRY_AVATAR_3_IMAGE_URL from './entry/entryAvatars/entryAvatar3.png';
import ENTRY_AVATAR_4_IMAGE_URL from './entry/entryAvatars/entryAvatar4.png';
import ENTRY_AVATAR_5_IMAGE_URL from './entry/entryAvatars/entryAvatar5.png';
import ENTRY_AVATAR_6_IMAGE_URL from './entry/entryAvatars/entryAvatar6.png';
import ENTRY_AVATAR_7_IMAGE_URL from './entry/entryAvatars/entryAvatar7.png';
import ENTRY_AVATAR_8_IMAGE_URL from './entry/entryAvatars/entryAvatar8.png';
import ENTRY_AVATAR_9_IMAGE_URL from './entry/entryAvatars/entryAvatar9.png';
import ENTRY_AVATAR_10_IMAGE_URL from './entry/entryAvatars/entryAvatar10.png';
import ENTRY_AVATAR_11_IMAGE_URL from './entry/entryAvatars/entryAvatar11.png';
import ENTRY_AVATAR_12_IMAGE_URL from './entry/entryAvatars/entryAvatar12.png';
import ENTRY_AVATAR_13_IMAGE_URL from './entry/entryAvatars/entryAvatar13.png';
import ENTRY_AVATAR_14_IMAGE_URL from './entry/entryAvatars/entryAvatar14.png';
import ENTRY_AVATAR_15_IMAGE_URL from './entry/entryAvatars/entryAvatar15.png';
export const ENTRY_AVATAR_IMAGE_URLS = [
    ENTRY_AVATAR_1_IMAGE_URL,
    ENTRY_AVATAR_2_IMAGE_URL,
    ENTRY_AVATAR_3_IMAGE_URL,
    ENTRY_AVATAR_4_IMAGE_URL,
    ENTRY_AVATAR_5_IMAGE_URL,
    ENTRY_AVATAR_6_IMAGE_URL,
    ENTRY_AVATAR_7_IMAGE_URL,
    ENTRY_AVATAR_8_IMAGE_URL,
    ENTRY_AVATAR_9_IMAGE_URL,
    ENTRY_AVATAR_10_IMAGE_URL,
    ENTRY_AVATAR_11_IMAGE_URL,
    ENTRY_AVATAR_12_IMAGE_URL,
    ENTRY_AVATAR_13_IMAGE_URL,
    ENTRY_AVATAR_14_IMAGE_URL,
    ENTRY_AVATAR_15_IMAGE_URL
];
